<i18n src="./../../i18n/contact_form.json"></i18n>

<template>
    <div id="contact" class="container">
        <div id="mt-contact">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="form pl-md-4">
                        <div class="contact-form">
                            <div>
                                <input id="contact_name" type="text" :placeholder="$t('form.name')" v-model="name"/>
                            </div>
                            <div>
                                <input id="contact_email" type="text" :placeholder="$t('form.email')" v-model="email"/>
                            </div>
                        </div>
                    </div>

                    <div class="mt-sm-only form pl-md-4 contact-form-wrapper">
                        <div class="contact-form">
                            <div class="text-left">
                                <div class="form-check pd-checkbox checkbox">
                                    <input type="checkbox" id="rodo-consent" v-model="rodoConsent">
                                    <label class="form-check pd-checkbox checkbox text-justify rodo-input" for="rodo-consent" v-html="$t('policy.consent')" />
                                </div>
                                <div class="form-check pd-checkbox checkbox">
                                    <input type="checkbox" id="owu-consent">
                                    <label class="form-check pd-checkbox checkbox text-justify owu-input" for="owu-consent" v-html="$t('policy.owuConsent')" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6 pr-md-4 text-right">
                    <div class="form">
                        <div class="contact-form">
                            <textarea id="contact_message" class="form-control" rows="17" :placeholder="$t('form.message')" v-model="message"></textarea>
                        </div>
                    </div>
                </div>

                <div class="mt-to-sm-only form ml-2 mr-2 contact-form-wrapper">
                    <div class="contact-form">
                        <div class="text-left">
                            <div class="form-check pd-checkbox checkbox">
                                <input type="checkbox" id="rodo-consent-sm" v-model="rodoConsent">
                                <label class="form-check pd-checkbox checkbox text-justify rodo-input" for="rodo-consent-sm" v-html="$t('policy.consent')" />
                            </div>
                            <div class="form-check pd-checkbox checkbox">
                                <input type="checkbox" id="owu-consent-sm">
                                <label class="form-check pd-checkbox checkbox text-justify owu-input" for="owu-consent-sm" v-html="$t('policy.owuConsent')" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 pr-4 text-right">
                    <button id="contact_submit" class="btn btn-primary btn-lg mt-button mt-button-primary mt-0 pl-5 pr-5" v-on:click="sendContactForm()" v-text="$t('form.send')"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import axios from "axios";
    import {Const} from "@/main";

    export default {
        name: "ContactForm",
        data () {
            return {
                name: '',
                email: '',
                message: '',
                rodoConsent: false
            }
        },
        methods: {
            sendContactForm() {
                var app = this;
                if (this.validateForm()) {
                    axios.post(Const.API_HOST + '/form/contact', {
                        name: this.name,
                        email: this.email,
                        message: this.message
                    }).then(function (response) {
                            if (response.status === 200) {
                                app.$router.push({name: 'contactThanks'})
                            }
                        }).catch(function (error) {
                        // eslint-disable-next-line no-console
                        console.log(error);
                    })
                }
            },
            validateForm() {
                let valid = true

                // imie
                if (this.name.trim() === '') {
                    valid = false
                    $('#contact_name').addClass('invalid-form')
                } else {
                    $('#contact_name').removeClass('invalid-form')
                }

                // email
                var emailReg = /\S+@\S+\.\S+/
                if (this.email.trim() === '' || !this.email.toLowerCase().match(emailReg)) {
                    valid = false
                    $('#contact_email').addClass('invalid-form')
                } else {
                    $('#contact_email').removeClass('invalid-form')
                }

                if (!this.rodoConsent) {
                    valid = false
                    $('.rodo-input').addClass('consent-error')
                } else {
                    $('.rodo-input').removeClass('consent-error')
                }

                // wiadomosc
                if (this.message.trim() === '') {
                    valid = false
                    $('#contact_message').addClass('invalid-form')
                } else {
                    $('#contact_message').removeClass('invalid-form')
                }

                return valid;
            }
        }
    }
</script>

<style scoped>
    #contact {
        padding-bottom: 50px;
    }

    .contact-form-wrapper.mt-sm-only {
        position: absolute;
        bottom: 26px;
    }
    .rodo-input, .rodo-input a {
        font-size: 14px;
        color: #fff;
    }
    .owu-input, .owu-input a {
        font-size: 14px;
        color: #fff;
    }

    .consent-error {
        border: 1px red solid;
    }
</style>